import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
// import { CSpinner } from '@coreui/react'
import Loading from '../views/components/notifications/modals/LoadingModal'

// routes config
import routes from '../routes'

const AppContent = () => {
  return (
    <div className="main-container">
      <Suspense className="main-container" fallback={<Loading openModal={true} />}>
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })}
        </Routes>
      </Suspense>
    </div>
  )
}

export default React.memo(AppContent)
